<ng-container *ngIf="result">
  <div class="col-12 px-2 pl-md-3 position-static"
       data-cy="result-item-job"
  >
    <div class="cursor-pointer pb-3 pb-md-0 job-description">
      <mb-link [dataEventLabel]="result?.title"
               [linkData]="{uid: cmsLinkType.SPECIAL, url: 'jobDetailPage', queryparams: { id: result?.jobId } }"
               [useSlot]="true"
               dataCy="result-item-link"
               styleClass="result-item"
               target="_self"
      >
        <strong [innerHTML]="result?.title | safeHtml"
                data-cy="result-item-text"
        ></strong>
      </mb-link>
      <span class="content-type"
            data-cy="result-item-job-field"
            *ngIf="result.jobField?.length"
      >{{ result.jobField }}</span>
    </div>
    <p class="job-location">
      <img src="assets/images/map_marker.svg"
           title="location-marker"
           alt=""
           height="18"
           data-cy="result-item-location-icon"
      >
      <span [innerHTML]="' ' + result?.city | safeHtml"
            data-cy="result-item-city"
      ></span>
    </p>
    <table data-cy="result-item-data">
      <tbody>
      <ng-container *ngTemplateOutlet="tableRow; context: { label: 'company', value: result?.company }"></ng-container>
      <ng-container *ngTemplateOutlet="tableRow; context: { label: 'experience', value: result?.experience }"></ng-container>
      <ng-container *ngTemplateOutlet="tableRow; context: { label: 'workTime', value: result?.workTime }"></ng-container>
      </tbody>
    </table>
  </div>
</ng-container>

<ng-template #tableRow
             let-label="label"
             let-value="value"
>
  <tr data-cy="job-result-table-row">
    <td class="attribute"
        [innerHTML]="(('jobSearch.' + label) | mbTranslate) + ':' | safeHtml"
    ></td>
    <td class="value"
        [innerHTML]="value | safeHtml"
    ></td>
  </tr>
</ng-template>